/**
 * @generated SignedSource<<2ae5b22d33923ae62c0eb9c486b2bf3c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion$data = {
  readonly " $fragmentSpreads": FragmentRefs<"addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion">;
  readonly " $fragmentType": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion";
};
export type async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion$key = {
  readonly " $data"?: async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "61023dc51339302e0390200141db5335";

export default node;
